import { render, staticRenderFns } from "./DocenteEditarTipos.vue?vue&type=template&id=7bd9823d&"
import script from "./DocenteEditarTipos.vue?vue&type=script&lang=js&"
export * from "./DocenteEditarTipos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports